import { render, staticRenderFns } from "./SharedPatient.vue?vue&type=template&id=6d12034f"
import script from "./SharedPatient.vue?vue&type=script&lang=js"
export * from "./SharedPatient.vue?vue&type=script&lang=js"
import style0 from "./SharedPatient.vue?vue&type=style&index=0&id=6d12034f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports